<template>
  <div class="register-one-step-page">
    <div class="register-form">
      <div class="title">快速注册</div>
      <div class="input-group register-one-input-phone">
        <div class="input-label"><img class="icon-img" src="../../assets/icon-login-phone.png"></div>
        <input class="mint-field-core form-input" v-model="phone" type="number" placeholder="请输入手机号">
      </div>
      <div v-if="!phone" class="form-btn-unactived" @click="checkRegister" >下一步</div>
      <div v-if="phone" class="form-btn-actived" @click="checkRegister" >下一步</div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import customerUserService from '../../service/customer/UserService'

  export default {
    name: 'RegisterStepOne',
    data () {
      return {
        phone: '',
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
    },
    methods: {
      checkPhone(){
        let phone = this.phone;
        if (phone == '') {
          Toast('请输入手机号码！');
          return false;
        }
        let re= /^1[3578]\d{9}$/;
        if(re.test(phone)){
          return true;
        } else {
          Toast('请输入11位手机号码！');
          return false;
        }
      },
      async checkRegister(){
        if (!this.checkPhone()) {
          return;
        }
        let {code,msg} = await customerUserService.checkRegister(this.phone,'2');
        if(code == '0'){
          let phone = this.phone;
          this.$router.push({name:'RegisterStepTwo',query:{phone}});
        }else {
          Toast(msg);
          return false;
        }
      },
    }
  }
</script>
<style lang="scss">
  .register-one-step-page{
    width: 7.5rem;
    height: 11.8rem;
    font-size: 0.36rem;
    color: #878e99;
    margin-top: -1rem;
    display: flex;
    background: white url("../../assets/icon-login-bg.png") no-repeat;
    background-position: center;
    background-size: cover;
    .register-form{
      width: 6.9rem;
      height: 6.1rem;
      margin: 2.1rem auto 0 auto;
      background-color: white;
      border-radius: 0.1rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem rgba(0, 0, 0, 0.1);
    }
    .title{
      height: 1.2rem;
      line-height: 1.2rem;
      margin-left: 0.3rem;
      color: #191818;
      font-weight: bold;
    }
    .input-group{
      height: 0.9rem;
      width: 6.54rem;
      margin: 0 auto;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      position: relative;
      font-size: .32rem;
      color: #191818;
    }
    .input-group .input-label{
      width: 0.28rem;
      height: 0.42rem;
      padding-left:0.34rem;
      padding-right:.15rem;
      flex-grow: 0;
      flex-shrink: 0;
    }
    .input-label .icon-img{
      width: 100%;
      height: 100%;
    }
    .input-group .form-input{
      border: none;
      width: 5.65rem;
      padding-left: .2rem;
      flex-grow: 1;
      outline: none;
      height: 0.78rem;
      font-size: .32rem;
      line-height: 0.78rem;
      border-bottom: solid 1px #e0dedc;
    }
    .register-one-input-phone{
      margin-top: 0.5rem;
      margin-bottom: 1.8rem;
    }
    .form-btn-actived{
      width: 2.8rem;
      height: 0.9rem;
      margin: 0.94rem auto 0rem auto;
      color: white;
      line-height: 0.9rem;
      text-align: center;
      border-radius: 0.45rem;
      background: #feac00;
    }
    .form-btn-unactived{
      width: 2.8rem;
      height: 0.9rem;
      margin: 0.94rem auto 0rem auto;
      color: white;
      line-height: 0.9rem;
      text-align: center;
      border-radius: 0.45rem;
      background-color: #e0dedc;
    }

    *::-webkit-input-placeholder { /* WebKit browsers*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
    *:-moz-placeholder {  /* Mozilla Firefox 4 to 18*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
    *::-moz-placeholder {  /* Mozilla Firefox 19+*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
    *:-ms-input-placeholder { /* Internet Explorer 10+*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
  }

</style>
